import * as IoC from 'typescript-ioc';
import * as ARTIFACTS_API from '../../constants/api/artifacts.constants';
import { IApiClient } from '../../infrastructure/api-client';
import { IEventRequestParams } from '../shared.dto';
import { IArtifactDTO, IArtifactForDownload, IArtifactPublicLinkDTO, IArtifactsDAO, IArtifactsParams, IInitialArtifactsListDTO, IRequestArtifactsPayload } from '../artifacts.dao';
import { LinkTargetValue } from '../../constants/common.constants';

class ArtifactsDAO extends IArtifactsDAO {
    constructor(
        @IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getAllArtifacts(params: IEventRequestParams): Promise<IInitialArtifactsListDTO> {
        const response = await this.apiClient.get<IInitialArtifactsListDTO>(ARTIFACTS_API.GET_MEETING_ARTIFACTS_URL, params);
        return response.parsedResponse;
    }

    public async downloadSingleArtifact(
        params: IEventRequestParams & { assetMetadataId: number },
        assetName: string
    ): Promise<void> {
        const { parsedResponse: {
            downloadUrl,
        } } = await this.apiClient.get<IArtifactForDownload>(ARTIFACTS_API.DOWNLOAD_ARTIFACT_URL, params);
        if (downloadUrl) {
            const a = document.createElement('a');
            a.download = assetName;
            a.href = downloadUrl;
            a.target = LinkTargetValue.BLANK;
            document.body.appendChild(a);
            a.click();
            a.remove();
        } else {
            throw new Error('Failed while downloading artifact. Please, try again later.');
        }
    }

    public async requestMeetingsArtifactsInBatch(params: IEventRequestParams & IRequestArtifactsPayload): Promise<void> {
        const response = await this.apiClient.post<void>(ARTIFACTS_API.REQUEST_ARTIFACTS_IN_BATCH, params);
        return response.parsedResponse;
    }

    public async deleteSingleArtifact(params: IArtifactsParams): Promise<void> {
        await this.apiClient.delete<void>(ARTIFACTS_API.DELETE_ARTIFACT_URL, params);
    }

    public async updateSingleArtifact(params: IArtifactsParams & { note: string }): Promise<IArtifactDTO> {
        const response = await this.apiClient.put<IArtifactDTO>(ARTIFACTS_API.EDIT_ARTIFACT_URL, params);
        return response.parsedResponse;
    }

    public async createArtifactLink(params: IArtifactsParams): Promise<IArtifactPublicLinkDTO> {
        const response = await this.apiClient.get<IArtifactPublicLinkDTO>(ARTIFACTS_API.CREATE_ARTIFACT_LINK, params);
        return response.parsedResponse;
    }

    public async deleteArtifactLink(params: IArtifactsParams): Promise<void> {
        await this.apiClient.delete<void>(ARTIFACTS_API.DELETE_ARTIFACT_LINK, params);
    }

    public async publishPassportReplay(params: IArtifactsParams): Promise<void> {
        await this.apiClient.get<void>(ARTIFACTS_API.PUBLISH_PASSPORT_REPLAY_URL, params);
    }
}

export { ArtifactsDAO };
